/**
 * Joins an array by commas and 'and'
 * For example it would convert ['one', 'two', 'three', 'four'] into 'one, two, three and four'
 */
const formatArrayAsList = (array?: string[]): string | undefined => {
    if (!array || !array.length) {
        return undefined;
    }
    if (array.length === 1) {
        return array[0];
    }
    const firsts = array.slice(0, array.length - 1);
    const last = array[array.length - 1];
    return `${firsts.join(', ')} and ${last}`;
};

export default formatArrayAsList;
